import * as types from "../actionTypes";

export const getList = pageNumber => {
  return {
    type: types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_REQUEST,
    pageNumber: pageNumber
  };
};

export const getListSuccess = data => {
  return {
    type: types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.MANAGER_GET_LIST_PETTY_CASH_BUDGET_FAILURE,
    error: error
  };
};

export const getInit = () => {
  return {
    type: types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_REQUEST
  };
};

export const getInitSuccess = data => {
  return {
    type: types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const getInitFailure = error => {
  return {
    type: types.MANAGER_GET_INIT_PETTY_CASH_BUDGET_FAILURE,
    error: error
  };
};

export const emptyCachedDataForCreate = () => {
  return {
    type: types.MANAGER_EMPTY_PETTY_CASH_BUDGET_CACHED_DATA_FOR_CREATE
  };
};

export const store = data => {
  return {
    type: types.MANAGER_STORE_PETTY_CASH_BUDGET_REQUEST,
    data: data
  };
};

export const storeSuccess = data => {
  return {
    type: types.MANAGER_STORE_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const storeFailure = () => {
  return {
    type: types.MANAGER_STORE_PETTY_CASH_BUDGET_FAILURE
  };
};

export const show = id => {
  return {
    type: types.MANAGER_SHOW_PETTY_CASH_BUDGET_REQUEST,
    id: id
  };
};

export const showSuccess = data => {
  return {
    type: types.MANAGER_SHOW_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const showFailure = error => {
  return {
    type: types.MANAGER_SHOW_PETTY_CASH_BUDGET_FAILURE,
    error: error
  };
};

export const get = id => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_BUDGET_REQUEST,
    id: id
  };
};

export const getSuccess = data => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_BUDGET_FAILURE,
    error: error
  };
};

export const update = (id, data) => {
  return {
    type: types.MANAGER_UPDATE_PETTY_CASH_BUDGET_REQUEST,
    id: id,
    data: data
  };
};

export const updateSuccess = data => {
  return {
    type: types.MANAGER_UPDATE_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const updateFailure = () => {
  return {
    type: types.MANAGER_UPDATE_PETTY_CASH_BUDGET_FAILURE
  };
};

export const remove = (id, reloadCurrentPage, pettyCashId) => {
  return {
    type: types.MANAGER_REMOVE_PETTY_CASH_BUDGET_REQUEST,
    id: id,
    reloadCurrentPage: reloadCurrentPage,
    pettyCashId: pettyCashId
  };
};

export const removeSuccess = data => {
  return {
    type: types.MANAGER_REMOVE_PETTY_CASH_BUDGET_SUCCESS,
    payLoad: data
  };
};
export const removeFailure = () => {
  return {
    type: types.MANAGER_REMOVE_PETTY_CASH_BUDGET_FAILURE
  };
};
